import { FormikProps } from "formik";
import moment from "moment";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMDatePicker from "src/components/UI/atoms/formFields/ATMDatePicker/ATMDatePicker";
import ATMMultiSelect from "src/components/UI/atoms/formFields/ATMMultiSelect/ATMMultiSelect";
import useAccounts from "src/hooks/useAccounts";
import { TransactionFilterDialogValues } from "src/models/Transactions.model";
import { paymentModeOptions } from "src/utils/paymentModeOptions";
import { transactionTypeOptions } from "src/utils/transactionTypeOptions";

type Props = {
  formikProps: FormikProps<TransactionFilterDialogValues>;
  onClose: () => void;
  handleReset: () => void;
};

const TransactionFilterDialog = ({
  formikProps,
  onClose,
  handleReset,
}: Props) => {
  const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;
  const { accounts } = useAccounts();
  const accountOptions = accounts?.map((account:any) => {
    return {
      label: account?.accountName,
      value: account?._id,
    };
  });
  return (
    <div className="p-4 flex flex-col gap-6">
      <div className="flex justify-between items-center">
        <div className="text-xl font-medium"> Filters </div>
        <button type="button" className="hover:bg-hover text-red-700 font-medium" onClick={handleReset}>
          Reset Filters
        </button>
      </div>
      <div className="flex flex-col gap-3">
      {/* CreatedAt Date */}
      <div className="border-l-[3px] border-primary-dark px-2 font font-medium text-[18px]  bg-white  text-primary-dark">
      CreatedAt Date
        </div>
       <div className="grid  grid-cols-2 gap-4">
       <div>
          <ATMDatePicker
            name="startDate"
            value={values.startDate}
            onChange={(newValue) => setFieldValue("startDate", newValue)}
            label="Start Date"
            format="DD-MM-YYYY"
            maxDate={moment().format("yyyy-MM-DD")}
          />
        </div>

        <div>
          <ATMDatePicker
            name="endDate"
            value={values.endDate}
            onChange={(newValue) => setFieldValue("endDate", newValue)}
            label="End Date"
            format="DD-MM-YYYY"
            minDate={values?.startDate || null}
          />
        </div>
       </div>
        {/* Payment Date */}
       <div className="border-l-[3px] border-primary-dark px-2 font font-medium text-[18px]  bg-white  text-primary-dark">
        Payment Date
        </div>
       <div className="grid  grid-cols-2 gap-4">
       <div>
          <ATMDatePicker
            name="paymentStartDate"
            value={values?.paymentStartDate}
            onChange={(newValue) => setFieldValue("paymentStartDate", newValue)}
            label="Start Date"
            format="DD-MM-YYYY"
            maxDate={moment().format("yyyy-MM-DD")}
          />
        </div>

        <div>
          <ATMDatePicker
            name="paymentEndDate"
            value={values?.paymentEndDate}
            onChange={(newValue) => setFieldValue("paymentEndDate", newValue)}
            label="End Date"
            format="DD-MM-YYYY"
            minDate={values?.paymentEndDate || null}
          />
        </div>
       </div>
       <div className="grid grid-cols-2 gap-4">
         {/* Transaction Type */}
         <div className="">
          <ATMMultiSelect
            name="transactionType"
            value={values.transactionType}
            onChange={(newValue) => setFieldValue("transactionType", newValue)}
            onBlur={handleBlur}
            label="Transaction Type"
            placeholder="Select Transaction Type"
            options={transactionTypeOptions}
          />
        </div>
        {/* Payment Mode */}
        <div className="">
          <ATMMultiSelect
            name="mode"
            value={values.mode}
            onChange={(newValue) => setFieldValue("mode", newValue)}
            onBlur={handleBlur}
            label="Payment Mode"
            placeholder="Select Payment Mode"
            options={paymentModeOptions}
          />
        </div>
        {/* Account */}
        <div className="">
          <ATMMultiSelect
            name="account"
            value={values?.account}
            onChange={(newValue) => setFieldValue("account", newValue)}
            onBlur={handleBlur}
            label="Account"
            placeholder="Select Account"
            options={accountOptions}
          />
        </div>
       </div>
      </div>
      <div className="flex gap-2">
        <button
          type="button"
          className="border w-full rounded p-2 h-[42px] flex gap-2 justify-center items-center bg-slate-200 hover:bg-slate-300"
          onClick={onClose} // Call onClsoe when clicked the button
        >
          Close
        </button>
        <ATMLoadingButton isLoading={isSubmitting} type="submit">
          Apply
        </ATMLoadingButton>
      </div>
    </div>
  );
};

export default TransactionFilterDialog;
